import type { RecheckView } from "@amber/profiles/contracts";
import { AppLink, Callout } from "@amber/ui";

export function RecheckProgress({ recheck, profileId }: { recheck: RecheckView; profileId: string }) {
  if (recheck.state === "queued")
    return (
      <Callout className="mt-3" title="Recheck of archived items queued">
        It starts when the plan applies.
      </Callout>
    );
  const total = recheck.items_total ?? 0;
  const pct = total === 0 ? 100 : Math.round((recheck.items_checked / total) * 100);
  if (recheck.state === "running") {
    return (
      <section aria-label="Recheck" className="mt-3 rounded-xl border border-divider px-3 py-2.5">
        <b className="font-strong">
          Rechecking {total.toLocaleString("en")} archived items for this person · {pct}% · {recheck.found} found
        </b>
        <div
          className="mt-2 h-1.5 overflow-hidden rounded-full bg-surface-3"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={pct}
          aria-label="Recheck progress"
        >
          <div className="h-full rounded-full bg-link" style={{ width: `${String(pct)}%` }} />
        </div>
      </section>
    );
  }
  return (
    <section aria-label="Recheck" className="mt-3 flex items-center gap-3 rounded-xl border border-divider px-3 py-2.5">
      <span className="flex-1">
        <b className="font-strong">
          Recheck finished · {recheck.items_checked.toLocaleString("en")} archived items · {recheck.found} found
        </b>
        {recheck.found_excluded > 0 ? (
          <span className="block text-md text-muted">
            {recheck.found_excluded === 1
              ? "1 of them had been excluded as not relevant and is"
              : `${String(recheck.found_excluded)} of them had been excluded as not relevant and are`}{" "}
            processed now.
          </span>
        ) : null}
      </span>
      {recheck.found > 0 ? <AppLink href={`/backlog?person=${profileId}`}>Show found items</AppLink> : null}
    </section>
  );
}
